import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.adminBicycleReceive.replace(appPath.admin, ''),
	components: () => [import(/* webpackChunkName: 'adminBicycleReceive' */ './component')],
	render: ([AdminBicycleReceive]) => <AdminBicycleReceive />,
};

export default routes;
